import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {
  QuickSelectionModel, QuickSelectionModelId,
  SelectionEventModel,
  TreeItemFlatNode,
  TreeItemNode
} from '@shared/models/tree-selector.models';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {ActivityFilterService} from '../../../../services/activity-filter.service';
import {takeUntil} from 'rxjs/operators';
import {PaymentStreamSetting} from '../../../../../../footprint/models/payment-stream-setting.model';

@Component({
    standalone: false,
    selector: 'particle-activity-filter-transactions-selector',
  templateUrl: './activity-filter-transactions-selector.component.html',
  styleUrls: ['./activity-filter-transactions-selector.component.scss']
})
export class ActivityFilterTransactionsSelectorComponent implements OnInit, OnDestroy, IDialogView {
  data: DialogModel;
  itemViewerName: string;
  solutionSelectorTitle: string;
  selectedTransactions: any[] = [];
  selectorData$: BehaviorSubject<TreeItemNode[]> = new BehaviorSubject([]);
  solutionSelectorData$: BehaviorSubject<TreeItemNode[]> = new BehaviorSubject([]);
  quickSelections$: Observable<QuickSelectionModel[]> = new Observable<QuickSelectionModel[]>();
  isParentNodeCollapsible$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  private ngUnsubscribe$ = new Subject<void>();
  selectedItems: Array<string> = [];
  valueChanged: boolean = false;
  allRecords: boolean = false;
  private allStreams: PaymentStreamSetting[] = [];

  constructor(private activityFilterService: ActivityFilterService) {
    this.quickSelections$ = of([
      {
        name: 'All Streams',
        id  : QuickSelectionModelId.ALL
      },
      {
        name: 'None',
        id  : QuickSelectionModelId.NONE
      }
    ]);
  }

  ngOnInit() {
    this.selectedItems = this.data.input.selectedItems;
    this.allRecords = this.data.input.allRecords;
    if(!this.selectedItems) {
      this.selectedItems = [];
    }
    this.setUpSolutionSelector();
  }


  onOkClicked(): boolean {
    //console.log('[all streams count] ', this.allStreams.length, this.selectedItems.length);
    if(this.allRecords && !this.valueChanged) {
      this.data.input.selectedItems = this.allStreams.map(p => p.stream.code);
    } else {
      this.data.input.selectedItems = this.valueChanged? this.selectedTransactions.map(item => item.code): this.selectedItems;
    }
    this.data.input.allItemsSelected = this.data.input.selectedItems.length === this.allStreams.length;
    return true;
  }


  setUpSolutionSelector() {
    this.solutionSelectorTitle = 'Transactions';
    this.itemViewerName = 'SolutionItemViewerComponent';
    this.isParentNodeCollapsible$.next(true);
    this.getTreeData();
  }

  onTransactionsSelectionChanged($event: SelectionEventModel) {
    this.selectedTransactions = $event.selectedTreeNodes.filter(o => o.item.isChecked === true).map(o => o.item);
    //console.log('[transaction settting: ]',$event);
    this.valueChanged = true;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onQuickSelectionClick($event: QuickSelectionModel) {

  }

  private getTreeData() {
    this.activityFilterService.getTransactionStreams().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
      this.allStreams = res;
      this.selectedItems = this.selectedItems.filter(code => this.allStreams.findIndex(s => s.stream.code === code) !== -1);
      const streamData = this.buildStreamSelectorTree(res);
      this.solutionSelectorData$.next(streamData);
    });
  }

  private buildStreamSelectorTree(streamSettings: PaymentStreamSetting[]) {
    //console.log('stream settings:', streamSettings);
    const data: TreeItemNode[] = [];
    streamSettings.forEach(settings => {
      let item = settings.stream;
      let isChecked = this.allRecords? true: this.selectedItems.indexOf(item.code) === -1 ? false: true;
      const node = new TreeItemNode();
      node.id = item.id;
      node.item = {
        id: item.id,
        code: item.code,
        name: item.title,
        isChecked: isChecked,
        expandable: false,
        threeLetterCode: item.threeLetterCode
      };
      data.push(node);
    });
    return data;
  }
}
